import React from 'react';
import { LuRefreshCw } from 'react-icons/lu';
import Avatar from '../../common/Avatar';
import Button from '../../common/Button';
import Card from '../../common/Card';
import { StudentReportStatusBadge } from './StudentReportCard';

/**
 * Top of one student's report: name, status, admission number, class and year, and Refresh.
 */
export default function StudentReportHeader({ report, onRefresh, isRefreshing }) {
    if (!report) return null;

    const details = [];
    if (report.admissionNo) details.push(`Adm. no. ${report.admissionNo}`);
    if (report.Class != null) details.push(`Class ${report.Class}${report.sec ? ` ${report.sec}` : ''}`);
    if (report.academicYear) details.push(report.academicYear);

    return (
        <Card>
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex min-w-0 flex-1 items-center gap-4">
                    <Avatar name={report.name || 'Student'} size="lg" />
                    <div className="min-w-0">
                        <div className="flex flex-wrap items-center gap-2">
                            <h2 className="text-lg font-semibold text-ui-ink">{report.name || 'Student report'}</h2>
                            <StudentReportStatusBadge status={report.status} />
                        </div>
                        {details.length > 0 && <p className="mt-0.5 text-sm text-ui-ink-2">{details.join(' · ')}</p>}
                    </div>
                </div>

                {onRefresh && (
                    <Button
                        variant="secondary"
                        onClick={onRefresh}
                        loading={isRefreshing}
                        leftIcon={<LuRefreshCw className="size-4" />}
                    >
                        Refresh
                    </Button>
                )}
            </div>
        </Card>
    );
}
